import { songs } from "../constants";
import { getTodaysSolution } from "./songLibrary";

export const todaysSolution = getTodaysSolution(songs);
